import { msg } from "@lingui/core/macro";

export const vehicleStateMatchRuleMessages = {
	name: msg({ message: "Vehicle Has Valid State" }),
	description: msg({ message: "Vehicle must have a valid state" }),
	errors: {
		invalidState: msg({ message: "Vehicle must have a valid state. Invalid States: ({states})" }),
	},
} as const;
